var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.6.2a1.1 1.1 0 0 0-1.1 1.1v1.1H2.4A2.2 2.2 0 0 0 .2 4.6v11a2.2 2.2 0 0 0 2.2 2.2h13.2a2.2 2.2 0 0 0 2.2-2.2v-11a2.2 2.2 0 0 0-2.2-2.2h-1.1V1.3a1.1 1.1 0 0 0-2.2 0v1.1H5.7V1.3A1.1 1.1 0 0 0 4.6.2zm0 5.5a1.1 1.1 0 1 0 0 2.2h8.8a1.1 1.1 0 0 0 0-2.2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7367a19371181d2dea8e0f1e16d1901f.svg";
export { ForwardRef as ReactComponent };